import { RegisterModule } from '@/typings/common'
import {
  VPRPublication as Data,
  VPRPublicationCollection as Collection,
} from '@/typings/api/VPRPublications'
import { VPRPublicationsApi as Api } from '@/api/resources/Collector/VPRPublicationsApi'

import { registerModule as vuexRegisterModule } from 'vuex-smart-module'
import { Builder } from '@/store/createCrudModule'
import { VPRPublicationsAdapter as Adapter } from './VPRPublicationsAdapter'
import { MODULE_NAME } from '../utils'


const useOptions = () => ({
  adapter: new Adapter(),
  idName: 'lk_publication_id' as const,
})

const storeModule = Builder<Data, Collection, Api>(useOptions)
export { storeModule as VPRPublicationsStoreModule }

export const registerModule: RegisterModule = ({ store }): void => {
  if (registerModule.installed) return

  vuexRegisterModule(
    store,
    MODULE_NAME,
    MODULE_NAME,
    storeModule,
  )

  registerModule.installed = true
}
